import Vue from 'vue'
import Vuex from 'vuex'
import App from '@/App'

import { polyfill } from 'es6-promise'
polyfill()

import store from '@/store'

import axios from 'axios'
Vue.prototype.$axios = axios

import moment from 'moment-timezone'
Vue.prototype.$moment = moment

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#sched-widget',
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js